import React, { useContext, useState } from "react";
import {
  Box,
  Heading,
  HStack,
  Image,
  Pressable,
  Text,
  useDisclose,
  VStack,
} from "native-base";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import styles from "./styles.module.css";
import colors from "../../../../constants/colors";
import { StateContext, StatusContext } from "../../../../contexts";
import Stepper from "../../../../components/stepper";
import API from "../../../../api";
import Modal from "../../../../components/modal";
import userTie from "../../../../assets/icons/user-tie.svg";
import routes from "../../../../routes";

function SignUpAgencyRntPage() {
  const navigate = useNavigate();
  const state = useContext(StateContext);
  const status = useContext(StatusContext);
  const [isRnt, setIsRnt] = useState(true);
  const [rnt, setRnt] = useState("");
  const [procedureRnt, setProcedureRnt] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { isOpen: isSuccessModal, onOpen: onOpenSuccessModal } = useDisclose();
  const {
    isOpen: isPromoterModal,
    onOpen: onOpenPromoterModal,
    onClose: onClosePromoterModal,
  } = useDisclose();

  const onSave = async () => {
    try {
      setIsLoading(true);
      await API(state.jwt).post("/agencies", {
        data: {
          rnt: isRnt ? rnt : null,
          procedureRnt: isRnt ? null : procedureRnt,
          users: [state.user.id],
        },
      });
      await state.refreshUser();
      onOpenSuccessModal();
    } catch (error) {
      status.updateErrorMessage(error);
    }
    setIsLoading(false);
  };

  return (
    <VStack paddingTop={50} alignItems="center">
      <Helmet>
        <title>
          Registro - Ingresa tu folio de Registro Nacional de Turismo
        </title>
      </Helmet>
      <Heading color={colors.secondary} fontSize="2xl" textAlign="center">
        Registrarse
      </Heading>
      <Stepper step={2} />
      <form
        className={styles.form}
        onSubmit={(e) => {
          e.preventDefault();
          onSave();
        }}>
        <VStack
          backgroundColor={colors.white}
          padding={10}
          borderRadius={5}
          space={5}>
          <Heading color={colors.secondary} fontSize="xl" textAlign="center">
            Ingresa tu folio de
            <br />
            Registro Nacional de Turismo
          </Heading>
          <HStack marginTop={5} space={5}>
            {isRnt ? (
              <label className={styles.input}>
                Número RNT
                <input
                  type="text"
                  value={rnt}
                  onChange={(e) => setRnt(e.target.value)}
                  required
                  disabled={isLoading}
                />
              </label>
            ) : (
              <label className={styles.input}>
                Folio de tramite RNT
                <input
                  type="text"
                  value={procedureRnt}
                  onChange={(e) => setProcedureRnt(e.target.value)}
                  required
                  disabled={isLoading}
                />
              </label>
            )}
          </HStack>
          <Pressable
            alignSelf="center"
            onPress={() => setIsRnt(!isRnt)}
            disabled={isLoading}>
            <Text underline color={colors.gray}>
              {isRnt ? "¿Tu folio se encuentra en tramite?" : "Atrás"}
            </Text>
          </Pressable>
        </VStack>
        <HStack space={5} marginTop={7} minH={10} alignItems="stretch">
          <button
            type="button"
            disabled={isLoading}
            onClick={onOpenPromoterModal}>
            <Box
              backgroundColor={colors.white}
              borderWidth={1}
              borderColor={colors.lightGray}
              paddingY={2}
              borderRadius="full">
              <Text color={colors.lightGray} textAlign="center">
                No cuento con el
              </Text>
            </Box>
          </button>
          <button disabled={isLoading}>
            <Box
              backgroundColor={colors.primary}
              borderWidth={1}
              borderColor={colors.primary}
              paddingY={2}
              borderRadius="full">
              <Text color={colors.white}>Continuar</Text>
            </Box>
          </button>
        </HStack>
      </form>
      <Modal isOpen={isSuccessModal}>
        <VStack padding={5} alignItems="center" space={5}>
          <BsFillCheckCircleFill color={colors.success} size={80} />
          <Heading fontSize="2xl" marginTop={3} textAlign="center">
            ¡Tu folio ha sido verificado con éxito!
          </Heading>
          <Heading fontSize="lg" fontWeight="normal">
            Comenzarás tu registro como
            <Heading bold fontSize="lg">
              {" "}
              Empresa
            </Heading>
          </Heading>
          <Pressable
            backgroundColor={colors.primary}
            minH={10}
            width="full"
            borderRadius={20}
            justifyContent="center"
            alignItems="center"
            onPress={() => navigate(routes.signUpAgencyData)}>
            <Text color={colors.white}>Continuar</Text>
          </Pressable>
        </VStack>
      </Modal>
      <Modal isOpen={isPromoterModal} onRequestClose={onClosePromoterModal}>
        <VStack padding={5} alignItems="center" space={5}>
          <Image src={userTie} width={20} height={20} />
          <Heading fontSize="2xl" marginTop={3} textAlign="center">
            Iniciarás tu registro
            <br />
            como promotor de viajes
          </Heading>
          <Pressable
            backgroundColor={colors.primary}
            minH={10}
            width="full"
            borderRadius={20}
            justifyContent="center"
            alignItems="center"
            onPress={() => navigate(routes.signUp)}>
            <Text color={colors.white}>Continuar</Text>
          </Pressable>
        </VStack>
      </Modal>
    </VStack>
  );
}

export default SignUpAgencyRntPage;
